<template>
  <div class="mt-3" v-if="birthdays?.length">
    <h6 class="sidebar-section-title mb-2">
      <i class="fa-solid fa-cake-candles me-2"></i>
      {{ $t('general.birthdays') }}
    </h6>

    <div class="sidebar-birthday-list">
      <div
          v-for="(user, index) of birthdays"
          :key="index"
          class="sidebar-birthday-item">

        <div class="sidebar-birthday-icon">
          <i class="fa-solid fa-gift"></i>
        </div>

        <div class="sidebar-birthday-data">
          <span class="user-name" :title="user?.fullName">{{ user?.fullName }}</span>
          <span class="birthday-date">{{ user?.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

defineProps({
  birthdays: {
    type: Array,
    required: true,
    default: () => []
  }
})
</script>

<style scoped>
.sidebar-section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sidebar-section-title i {
  color: v-bind(companyColor);
}

.sidebar-birthday-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 4px;
}

.sidebar-birthday-list::-webkit-scrollbar {
  width: 4px;
}
.sidebar-birthday-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.sidebar-birthday-item {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
  transition: all 0.2s ease;
}

.sidebar-birthday-item:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.sidebar-birthday-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: v-bind(companyBgColor);
  color: v-bind(companyColor);
  border-radius: 4px;
  font-size: 0.75rem;
  margin-right: 10px;
  flex-shrink: 0;
}

.sidebar-birthday-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.birthday-date {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>